<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom" @click="showBox">
          <div class="left">{{text}}</div>
          <div class="right"><span>{{type}}</span><img src="../../../../assets/guideSystem/right_arrow.png" alt=""></div>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="goBack">
          <van-button type="primary">保存</van-button>
        </div>
        <div class="save" @click="$router.go(-1)">
          返回
        </div>
      </div>
      <van-action-sheet
        v-model="isshow"
        :actions="actions"
        description="请选择指挥中心"
        @select="onSelect"
      />
    </div>
  </div>
</template>
<script>
    export default {
        data () {
            return {
                isshow: false,
                actions: this.$store.state.complaint.type||[],
                type: '请选择',
                selectItem: '',
                text: '指挥中心'

            };
        },
        created () {
            console.log(this.actions);
        },
        methods: {
            showBox () {
                this.isshow = true;
            },
            onSelect (item) {
                this.selectItem = item;
                this.type = item.name;
                this.isshow = false;
            },
            goBack () {
                if (this.type === '请选择') {
                    this.$Toast('请选择指挥中心');
                    return;
                }
                var allType = this.$store.state.complaint.addType;
                if (allType.length >= 1) {
                    for (var i = 0; i < allType.length; i++) {
                        console.log(allType[i]);
                        if (allType[i].name === this.selectItem.name) {
                            allType.splice(i, 1);
                            this.$store.commit('complaint/resetType', allType);
                            break;
                        }
                    }
                    this.$store.commit('complaint/addType', this.selectItem);
                    this.$router.back();
                } else {
                    this.$store.commit('complaint/addType', this.selectItem);
                    this.$router.back();
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          color: #aaa;
          img {
              float: right;
              display: inline-block;
              height: 15px;
              width: 15px;
              margin-top: 17px;
          }
        }
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
   .btn {
      margin-top: 50px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .save {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
          height: 44px;
          line-height: 44px;
          background-color: #f0f0f0;
          color: #9c9090;
          text-align: center;
          border-radius: 5px;
          border: solid 1px #dcdcdc
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
